/** Status of remote data. */
export type Status = 'initial' | 'pending' | 'success' | 'failure';
